import { stringToElements } from '../helpers/index.js';
import { getOpenWalletLink } from '../pricing/links.js';

// Insert the My Wallet Widget
export const insertSearchBudget = (config, location) => {
    const { searchByBudget, linkColorConfig } = config;
    const linkColor = linkColorConfig && linkColorConfig.length > 0 ? linkColorConfig[0] : '';
    const selector = `[data-location~="${location}"]`;
    const elems = Array.from(document.querySelectorAll(selector));
    if (elems.length === 0) return;

    elems.forEach(elem => {
        const pricingFacetTemplate = `
            <button class="btn btn-unstyled btn-my-wallet-integration p-0 border-0 mt-4 ${linkColor}">
                <span class="mywallet-icon light"></span>
                <span class="wallet-link"></span>
            </button>
        `;
        const markup = stringToElements(pricingFacetTemplate);
        const textColor = linkColor === 'light' ? 'text-neutral-0' : 'text-body';
        const openWalletLink = getOpenWalletLink(searchByBudget, `${textColor} text-no-decoration ddc-font-size-small`, false, false, null, 'budget');
        markup.querySelector('.wallet-link').appendChild(openWalletLink);
        elem.appendChild(markup);
        if (elem.classList) {
            elem.classList.remove('hide', 'hidden');
        }
    });
};
